<template>
  <div class="container-fluid px-0" style="overflow: hidden; min-height: 100vh">
      <navbarLogin></navbarLogin>
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-2 col-2">
        <!-- <img src="../assets/Rectangle.png" class="leftImage" /> -->
      </div>
      <div class="col-lg-8 col-md-8 col-sm-8 col-8">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="signup">Change Password</div>
            <form>
              <div class="form-group text-left">
                <label>Password</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control input-lg"
                  id="Password"
                  @change="validatePassword"
                  placeholder="* * * * * * * *"
                required/>
                <span v-if="!isvalidPassword" id="warningText"><i class="fa fa-times-circle"></i> {{passwordMessage}}</span>
              </div>
              <div class="form-group text-left">
                <label>Re-Enter Password</label>
                <input
                  v-model="repassword"
                  type="password"
                  class="form-control input-lg"
                  id="rePassword"
                  @change="confirmedPassword"
                  placeholder="* * * * * * * *"
                required/>
                <span v-if="!isvalidRePassword" id="warningText"><i class="fa fa-times-circle"></i> {{repasswordMessage}}</span>
              </div>
              <div class="button pt-3">
                <button type="button"
                        class="btn btn-primary signupbtn"
                        @click="changePassword">Submit</button>
                <span class="already" @click="goTologin">Go To Login</span>
              </div>
            </form>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-6 d-none mt-5 pt-5 d-sm-block img-container">
            <img src="../assets/Group 4.png" class="img-fluid" alt="group 4 img" />
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-2 col-sm-2 col-2 text-right mr-0 pr-0 mt-auto">
        <!-- <img src="../assets/Path 2.png" class="rightImage" style="pointer-events: none; position: relative; left: 31px" /> -->
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Toasted from 'vue-toasted'
import axios from 'axios'
import Vue from 'vue'
import { settings } from '@/settings'
import navbarLogin from './navbarLogin'
import $ from 'jquery'

Vue.use(Toasted)
export default {
  data() {
    return {
      repassword: '',
      password: '',
      isvalidPassword: true,
      passwordMessage: '',
      hidePassword: true,
      // repassword: '',
      isvalidRePassword: true,
      repasswordMessage: ''
    }
  },
  components: {
    navbarLogin: navbarLogin
  },
  methods: {
    goTologin() {
      this.$router.push('/login')
    },
    validatePassword() {
      /* eslint-disable */
      var field = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
      // alert(field.test(this.password))
      if (!field.test(this.password)) {
        this.isvalidPassword = false
        this.passwordMessage = 'Please use 1 capital, 1 lower, 1 no., 1 special character and length should be greater then 8'
        $('#Password').css('border-color', 'red')
      } else {
        this.isvalidPassword = true
        $('#Password').css('border-color', '#ced4da')
      }
    },
    confirmedPassword() {
      if (this.password === this.repassword) {
        this.isvalidRePassword = true
        $('#rePassword').css('border-color', '#ced4da')
      } else {
        this.repasswordMessage = 'password not matched'
        this.isvalidRePassword = false
        $('#rePassword').css('border-color', 'red')
      }
    },
    changePassword() {
      if (this.password !== this.repassword) {
        $('#rePassword').css('border-color', 'red')
        return false
      } else if (this.password === '' || this.repassword === '') {
        this.$toasted.show('Please fill inputs', { duration: 2000 })
        return false
      }
      // changes the access_token for email for password change
      axios.post(`${settings.API_SERVER}user/changePassword/${this.$route.query.token}`, {password: this.password, generatePassword: false})
        .then(response => {
          this.$toasted.show('Password changed successfully', { duration: 2000 })
        })
        .catch(err => {
          this.$toasted.show('link expired please go to forgot password', { duration: 2000 })
          console.log('error', err)
        })
    }
  }
}
</script>
<style scoped>
.signup {
  font-family: Ubuntu;
  font-weight: 700;
  font-size: 38px;
  color: #3b3b3b;
  text-align: left;
  margin-top: 25%;
}
.getstarted,.invalid {
  opacity: 0.7;
  font-family: Ubuntu;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 24px;
}
label {
  font-family: Ubuntu;
  font-weight: 400;
  font-size: 12px;
  color: #606060;
  padding-left: 5px;
  padding-right: 5px;
}
.signupbtn {
  background: #2295c8;
  border-radius: 30px;
  width: 108px;
  height: 44px;
  font-family: ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  border: none;
}

.signupbtn:hover {
  background: #2295c8;
}
.img-container {
  margin-top: 20%;
  width: 100%;
}
.form-group > label {
  position: relative;
  left: 19px;
  top: 15px;
  background: white;
}
.input {
  padding-top: 2px;
  font-family: ubuntu;
  font-weight: 300;
  color:white;
}

@media only screen and (max-width: 600px) {

}
.already {
  font-family: "Ubuntu";
  font-weight: 500;
  font-size: 14px;
  color: #2295c8;
  line-height: 20px;
  margin-left: 5%;
  cursor: pointer;
}
#warningText {
  color: red;
  opacity: 0.7;
  font-size: 12px;
  font-family: "Ubuntu";
}
.leftImage {
  transform: rotate(180deg);
  /* margin-top: -270px; */
  margin-top: -165px;
  margin-left: -29px;
}
.rightImage {
  -webkit-transform: rotateY(218deg);
  margin-left: -21px;
  margin-bottom: -46px;
}
</style>
